import { useLocation, useNavigate } from "react-router-dom";

const Breadcrumb = ({ onCategoryClick, isMSR }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const parentPath = isMSR ? "msr-seasons" : "filter-product";
  const segments = location.pathname.split("/").filter(Boolean);

  let categorySegments = [];
  const idx = segments.indexOf(parentPath);

  if (isMSR) {
    categorySegments = ["MSR"];

    if (idx !== -1) {
      categorySegments = [...categorySegments, ...segments.slice(idx + 1)];
    }
  } else {
    categorySegments = idx !== -1 ? segments.slice(idx + 1) : [];
  }

  const handleBreadcrumbClick = (name, index) => {
    let newPath;

    if (isMSR) {
      if (index === 0) {
        newPath = "/msr-seasons/season";
      } else {
        newPath = `/${parentPath}/${categorySegments
          .slice(1, index + 1)
          .join("/")}`;
      }
    } else {
      newPath = `/${parentPath}/${categorySegments
        .slice(0, index + 1)
        .join("/")}?view=apparel`;
    }

    if (onCategoryClick) {
      onCategoryClick(newPath);
    }

    navigate(newPath, { replace: true });
  };

  return (
    <div className="ml-1.5">
      <div className="breadcrumb flex items-center">
        {categorySegments.map((name, index) => {
          const newPath = isMSR
            ? index === 0
              ? "/msr-seasons/season"
              : `/${parentPath}/${categorySegments
                  .slice(1, index + 1)
                  .join("/")}`
            : `/${parentPath}/${categorySegments
                .slice(0, index + 1)
                .join("/")}?view=apparel`;

          // console.log("new path in breadcrumb - ", newPath);
          // console.log("location pathname - ", location.pathname);

          return (
            <span
              key={`${index}-${newPath}`}
              onClick={() => handleBreadcrumbClick(name, index)}
              style={{
                cursor:
                  location.pathname === newPath.split("?")[0]
                    ? "default"
                    : "pointer",
                fontWeight:
                  location.pathname === newPath.split("?")[0]
                    ? "bold"
                    : "normal",
              }}
              className="!text-3xl"
            >
              {index > 0 && " > "}
              {decodeURIComponent(name).replace(/-\d+$/, "")}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default Breadcrumb;
